import React, { useState, Fragment, useEffect } from 'react'
import AniLink from 'gatsby-plugin-transition-link/AniLink'
import { useSpring, animated } from 'react-spring'

import {
  Slide,
  AppBar,
  Toolbar,
  Grid,
  useScrollTrigger,
  IconButton,
  Backdrop,
} from '@material-ui/core'
import { Logo } from '../../_common'
import { IoIosMenu } from 'react-icons/io'
import { GrClose } from 'react-icons/gr'

import { navbarLinks } from '../../../constants/links'
import useStyles from './styles'
import { usePath } from '../../../hooks'

function HideOnScroll(props) {
  const { children, window } = props

  const trigger = useScrollTrigger({
    target: typeof window !== 'undefined' ? window() : undefined,
  })
  return (
    <Fragment>
      {props.withNav ? (
        <Fragment>{children}</Fragment>
      ) : (
        <Slide appear={false} direction="down" in={!trigger}>
          {children}
        </Slide>
      )}
    </Fragment>
  )
}

const Navbar = (props) => {
  const [isWindowOnTop, setIsWindowOnTop] = useState(!props.withNav)
  const [isOpen, setNav] = useState(false)
  const {
    backdrop,
    appBar,
    navbar,
    navbarMask,
    navLinks,
    logoContainer,
    selectedNavLink,
    logoBtn,
    menuContainer,
    hidden,
    animWrapper,
  } = useStyles({ isWindowOnTop, isOpen, props })

  const [path] = usePath()

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.onscroll = () => {
        if (window.pageYOffset <= 200 && !props.withNav) {
          setIsWindowOnTop(true)
        } else {
          setIsWindowOnTop(false)
        }
      }
    }
    return () => {
      setIsWindowOnTop(false)
    }
  }, [props.withNav])

  useEffect(() => {
    if (isOpen) {
      document.getElementsByTagName('body')[0].style.overflow = 'hidden'
    } else {
      document.getElementsByTagName('body')[0].style.overflow = 'scroll'
    }
  }, [isOpen])

  const toggleNav = () => {
    setNav((isOpen) => !isOpen)
  }

  const fadeOutProps = useSpring({
    opacity: isOpen ? 1 : 0,
  })
  const fadeInProps = useSpring({ opacity: isOpen ? 0 : 1 })

  return (
    <Fragment>
      <Fragment>
        <HideOnScroll {...props}>
          <AppBar classes={{ root: appBar }}>
            <Toolbar
              classes={{
                root: navbar,
              }}
            >
              <div className={navbarMask} />
              <Grid container>
                <Grid
                  item
                  container
                  xs={6}
                  sm={3}
                  md={2}
                  className={logoContainer}
                >
                  <AniLink to="/" fade>
                    <Logo width={32} />
                  </AniLink>
                </Grid>
                <Grid item xs={6} sm={9} ms={10} className={menuContainer}>
                  <Fragment>
                    <IconButton onClick={toggleNav} className={logoBtn}>
                      {!isOpen ? (
                        <animated.div style={fadeInProps}>
                          <IoIosMenu />
                        </animated.div>
                      ) : (
                        <animated.div style={fadeOutProps}>
                          <GrClose />
                        </animated.div>
                      )}
                    </IconButton>
                    <animated.div
                      style={fadeOutProps}
                      className={
                        isOpen ? animWrapper : `${animWrapper} ${hidden}`
                      }
                    >
                      <ul
                        className={isOpen ? navLinks : `${navLinks} ${hidden}`}
                      >
                        {navbarLinks.map((e, i) => (
                          <li
                            key={i}
                            className={path === e.path ? selectedNavLink : ''}
                          >
                            <AniLink
                              fade
                              to={e.path}
                              duration={2}
                              onClick={toggleNav}
                            >
                              {e.text}
                            </AniLink>
                          </li>
                        ))}
                      </ul>
                    </animated.div>
                    <Backdrop
                      className={backdrop}
                      open={isOpen}
                      onClick={toggleNav}
                    />
                  </Fragment>
                </Grid>
              </Grid>
            </Toolbar>
          </AppBar>
        </HideOnScroll>
        <Toolbar />
      </Fragment>
    </Fragment>
  )
}

export default Navbar
